import {Injectable} from '@angular/core';
import {LocalStorageService} from './local-storage.service';
import {LoginSuccessResponse} from '../model/login-success-response';
import {TokenService} from './token.service';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {HttpClient} from '@angular/common/http';
import {ApiRoutes} from '../../../config/api-routes';
import {TranslateService} from '../../../../../node_modules/@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { EnvironmentType } from '../enums/enums';

@Injectable()
export class AuthorizationService {

  readonly REFRESH_TOKEN_TAG: string = 'jwt_refresh_token_' + environment.environmentName;
  readonly TOKEN_TAG: string = 'jwt_' + environment.environmentName;

  constructor(private localStorageService: LocalStorageService, private tokenService: TokenService, private translate: TranslateService,
              private cookieService: CookieService, private httpClient: HttpClient, private routes: ApiRoutes) {
  }

  public isUserLoggedIn(): boolean {
    return this.cookieService.check(this.TOKEN_TAG);
  }

  public signInOnLocalEnv(respone: LoginSuccessResponse) {
    this.tokenService.setToken(respone.token);
    this.tokenService.setRefreshToken(respone.refreshToken);
    this.setLocalization();
  }

  public signIn() {
    this.refreshTokensIfNeeded();
    this.setLocalization();
  }

  public signout() {
    this.tokenService.clearTokens();
  }

  public refreshTokensIfNeeded() {
    if (!this.tokenService.doesTokenExistLocally() || this.tokenService.getToken() !== this.getTokenFromCookies()) {
      this.tokenService.setToken(this.getTokenFromCookies());
      this.tokenService.setRefreshToken(this.getRefreshTokenFromCookies());
    }
  }

  private setLocalization() {
    this.localStorageService.setCulture(this.tokenService.getCulture());
    this.translate.use(this.tokenService.getCulture());
  }

  private getTokenFromCookies(): string {
    return this.cookieService.get(this.TOKEN_TAG);
  }

  private getRefreshTokenFromCookies(): string {
    return this.cookieService.get(this.REFRESH_TOKEN_TAG);
  }
}
